var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefund = function SvgRefund(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94 3.232a5.016 5.016 0 1 1-1.714 2.763l.038-.157.97.255a4.012 4.012 0 1 0 1.531-2.231l-.11.083.51.51-2.306.532.532-2.305.55.55Z",
    fill: "#4B4F54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.122 8.956v.786H5.717l-.155-.506c.211-.205.365-.414.464-.624.098-.216.147-.482.147-.8 0-.033-.004-.087-.014-.162h-.78v-.674h.584a3.09 3.09 0 0 1-.14-.864c0-.318.067-.592.203-.821.14-.234.334-.412.583-.534.248-.121.533-.182.856-.182.52 0 .915.145 1.187.435.276.286.42.653.435 1.102H8.18c-.005-.224-.063-.4-.175-.526-.113-.131-.288-.197-.527-.197-.22 0-.395.066-.526.197-.127.13-.19.332-.19.603 0 .122.012.244.035.366.028.117.068.257.12.42h1.32v.675H7.092c.01.075.014.13.014.168 0 .202-.04.403-.12.604a1.512 1.512 0 0 1-.35.534h2.485Z",
    fill: "#4B4F54"
  })));
};
export default SvgRefund;